"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientTransactionStatus = void 0;
// https://docs.google.com/spreadsheets/d/1B5JXbiO9mqe21cLTWIOSVYQq03fzxVjhSLe-rMhAuxI/edit#gid=436931725
// statuses listed as possible result status here https://www.wix.com/velo/reference/wix-pay/startpayment
var ClientTransactionStatus;
(function (ClientTransactionStatus) {
    ClientTransactionStatus["Successful"] = "Successful";
    ClientTransactionStatus["Pending"] = "Pending";
    ClientTransactionStatus["Failed"] = "Failed";
    ClientTransactionStatus["Chargeback"] = "Chargeback";
    ClientTransactionStatus["Refunded"] = "Refunded";
    ClientTransactionStatus["Offline"] = "Offline";
    ClientTransactionStatus["PartiallyRefunded"] = "PartiallyRefunded";
    ClientTransactionStatus["Cancelled"] = "Cancelled";
    ClientTransactionStatus["Undefined"] = "Undefined";
})(ClientTransactionStatus || (exports.ClientTransactionStatus = ClientTransactionStatus = {}));
//# sourceMappingURL=ClientTransactionStatus.js.map